/**
 * Returns a prop object safe for style-mode resolution by omitting `className`
 * and `style`, which are often used for internal composition and should not
 * force legacy mode in nested components.
 */
export function getStyleModeSafeProps<TProps extends object>(props: TProps): TProps {
  const { className: _className, style: _style, ...rest } = props as TProps & {
    className?: unknown;
    style?: unknown;
  };

  return rest as TProps;
}
